import { render, staticRenderFns } from "./MobileDevices.vue?vue&type=template&id=338350d7&scoped=true"
import script from "./MobileDevices.vue?vue&type=script&lang=js"
export * from "./MobileDevices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338350d7",
  null
  
)

export default component.exports